import type { CSSProperties } from 'react';

type FontType = {
  base: string;
  heading: string;
  emphasis: string;
};

type FontSize = {
  h1: number;
  h2: number;
  h3: number;
  h4: number;
  h5: number;
  h6: number;
  input: number;
  regular: number;
  medium: number;
  small: number;
  tiny: number;
};

type FontStyle = {
  [key: string]: CSSProperties;
};

type Fonts = {
  type: FontType;
  size: FontSize;
  style: FontStyle;
};

const Fonts: Fonts = {
  type: {
    base: 'TWK Everett', // body & UI
    heading: 'Teodor', // headings
    emphasis: 'TWK Everett', // italic/emphasis defaults
  },
  size: {
    h1: 38,
    h2: 34,
    h3: 30,
    h4: 26,
    h5: 20,
    h6: 19,
    input: 14,
    regular: 17,
    medium: 14,
    small: 12,
    tiny: 8.5,
  },
  style: {
    // Headings (Teodor)
    h1: {
      fontFamily: 'Teodor',
      fontSize: 38,
      fontWeight: 600, // Teodor SemiBold
    },
    h2: {
      fontFamily: 'Teodor',
      fontSize: 34,
      fontWeight: 600, // Teodor SemiBold
    },
    h3: {
      fontFamily: 'Teodor',
      fontSize: 30,
      fontWeight: 400,
      fontStyle: 'italic', // Teodor RegularItalic exists at 400
    },
    h4: {
      fontFamily: 'Teodor',
      fontSize: 26,
      fontWeight: 400, // Teodor Regular
    },
    h5: {
      fontFamily: 'Teodor',
      fontSize: 20,
      fontWeight: 400,
    },
    h6: {
      fontFamily: 'Teodor',
      fontSize: 19,
      fontWeight: 400,
      fontStyle: 'italic',
    },

    // Body/UI (TWK Everett)
    normal: {
      fontFamily: 'TWK Everett',
      fontSize: 17,
      fontWeight: 400, // TWK Everett Regular
    },
    input: {
      fontFamily: 'TWK Everett',
      fontSize: 14,
      fontWeight: 400,
    },
    description: {
      fontFamily: 'TWK Everett',
      fontSize: 14,
      fontWeight: 300, // TWK Everett Light for secondary text
    },
  },
};

export default Fonts;
